import React from 'react';
import { resolveLegacyView, NavigationItem } from '../../core/navigation';
import { moduleRegistry } from '../../modules.registry';
import { View } from '../../types';
import Sidebar from '../../components/Sidebar';
import Topbar from '../../components/Topbar';
import BottomBar from '../../components/BottomBar';

interface AppShellProps {
  children: React.ReactNode;
  currentView: View | 'admin';
}

interface AppShellPropsExtended extends AppShellProps {
  setCurrentView: (view: any) => void;
  isSidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export function AppShell({ children, currentView, setCurrentView, isSidebarCollapsed, toggleSidebar }: AppShellPropsExtended) {
  let navigationItems: NavigationItem[] = [];

  const legacy = resolveLegacyView(String(currentView));
  const registeredModule = moduleRegistry.findRouteByLegacyView(String(currentView));
  if (registeredModule?.manifest.navigation) {
    navigationItems = registeredModule.manifest.navigation.map((item) => ({
      ...item,
      icon: item.icon,
    }));
  }

  const activePath = legacy?.path ?? '';

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans relative overflow-x-hidden">
      {/* Premium Background Details */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-[0.02]" />
        <div className="absolute top-0 left-0 w-full h-[500px] bg-gradient-to-b from-blue-50/20 to-transparent" />
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-blue-100/10 blur-[120px] rounded-full" />
      </div>

      <Sidebar
        isCollapsed={isSidebarCollapsed}
        toggleSidebar={toggleSidebar}
        currentView={currentView}
        setCurrentView={setCurrentView}
        activePath={activePath}
      />

      <div className={`transition-[margin,padding] duration-300 flex-1 min-w-0 ${isSidebarCollapsed ? 'lg:ml-[84px]' : 'lg:ml-[280px]'}`}>
        <Topbar
          isSidebarCollapsed={isSidebarCollapsed}
          toggleSidebar={toggleSidebar}
          setCurrentView={setCurrentView}
          currentView={currentView}
        />
        <main className="mt-16 lg:mt-20 px-3 sm:px-4 md:px-5 pb-24 pt-3 lg:pt-4 flex flex-col gap-4 md:gap-5 w-full xl:max-w-none min-h-[calc(100vh-5.5rem)] overflow-hidden">
          {children}
        </main>
      </div>
      {/* BottomBar is rendered by the application container (App.tsx) */}
    </div>
  );
}
